import React from 'react';

const ConsultingOneOne = () => {
  const codes = {
    '12-Month Private Access & Mentorship': {
      offerPrice: '12,00,000 BDT',
      topics: [
        'A year-long transformational journey under Jahid Hasan’s direct mentorship. Includes private sessions, priority access, business audits, income strategy, growth planning, and personal development.',
        'Best for: Entrepreneurs, leaders & impact-driven creators building legacy-level businesses and balanced lives.',
      ],
    },
  };

  const boxStyle = {
    flex: '1 1 400px', // <-- Base width for the card
    padding: '20px',
    border: '1px solid violet',
    backgroundColor: 'rgba(238, 130, 238, 0.1)',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };


  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
      {Object.entries(codes).map(([codeTitle, { offerPrice, topics }]) => (
        <div key={codeTitle} style={boxStyle}>
          <div>
            <h3 style={{ color: '', marginBottom: '10px' }} className='text-center'>{codeTitle}</h3>
            <ul style={{ paddingLeft: '20px' }}>
              {topics.map((topic, idx) => (
                <li key={idx} style={{ marginBottom: '8px' }}>{topic}</li>
              ))}
            </ul>
          </div>
          <div style={{ marginTop: 'auto', textAlign: 'center' }}>
            <h4 style={{ margin: '20px 0 10px 0' }}>
              Starting From:
              <span style={{ color: 'green', fontWeight: 'bold', paddingLeft: '10px' }}>
                {offerPrice}
              </span>
            </h4>
            <button className='btn-default mt-5 mb-5'><a href='#consultingform'>BOOK NOW</a></button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConsultingOneOne;
